<template>
  <span class="multi-line-cell" :style="column.align?`text-align:${column.align}`:''">{{absence[column.columnName]}}</span>
</template>
<script>

export default {
  name:'MultiLineTextCell',
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
    isDisabled:{type:Boolean,default:false}
  },
}
</script>
<style scoped>
.multi-line-cell{
  white-space: break-spaces;
 overflow-y:scroll
}

</style>